import gql from 'graphql-tag';

export const UPLOAD_EQUIPMENT_ASSETS = gql`
  mutation UploadEquipmentImages($input: EquipmentUploadAssetsInput!) {
    equipment {
      result: uploadAssets(input: $input) {
        error
        success
        entities {
          id
          type
          source
          createdDateTime
        }
      }
    }
  }
`;
